import { Component, inject } from '@angular/core';
import { SvgIconService } from '../../services/svg-icon.service';
import { Subscription } from 'rxjs';
import { CommonDataPassService } from '../../services/common-data-pass.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-custom-toaster',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './custom-toaster.component.html',
    styleUrl: './custom-toaster.component.scss'
})
export class CustomToasterComponent {
    icons = inject(SvgIconService).icons
    isShowToast: boolean = false;
    popUpSub!: Subscription;

    toastMessage: string = '';
    toastType: string = '';
    toastTimeOut: number = 0;

    constructor(
        private commonDatapassService: CommonDataPassService,
    ) { }

    ngAfterViewInit() {
        this.popUpSub = this.commonDatapassService.customToastr$.subscribe((item: any) => {
            this.open(item);
        })
    }

    open(item: any) {
        if (item?.isOpen) {
            this.isShowToast = true;
            this.toastMessage = item?.message ?? '';
            this.toastType = item?.type;
            this.toastTimeOut = item?.timeout ?? 0;
            setTimeout(() => {
                this.isShowToast = false;
            }, item?.timeout);
        }
    }

    ngOnDestroy() {
        if (this.popUpSub) {
            this.popUpSub.unsubscribe();
        }
    }
}
